"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationResult = void 0;
class ValidationResult {
    constructor() {
        this.valid = true;
        this.errors = [];
    }
}
exports.ValidationResult = ValidationResult;
exports.default = ValidationResult;
//# sourceMappingURL=ValidationResult.js.map